<div class="remainin-count-info">
    <div class="contents" [ngClass]="loginQESCurrent ? 'show' :  'hide '"> 
        <mat-card-header>
            <mat-card-title>
                <span class="close-margin" *ngIf="packageName">
                    {{'profileTexts.packageName' | translate}}
                    <strong>
                        {{ planName }}
                    </strong>
                </span>
                <span class="close-margin">
                    {{'profileTexts.remainingCount' | translate}}
                    <ng-template [ngIf]="isInfinite" [ngIfElse]="remainingCount">
                        <span class="infinite-font rc-value">&infin;</span>
                    </ng-template>
                    <ng-template #remainingCount>
                        <strong>
                            {{packageRemainingCount}}
                        </strong>
                    </ng-template>
                </span>
                <span class="close-margin" *ngIf="packageExperationDate">
                    {{'profileTexts.packageExperationdDate' | translate}}
                    <strong>
                        {{packageExperationDate | date: dateTimeFormat}} <span> {{getYearUnit()}}</span>
                    </strong>
                </span>
            </mat-card-title>
        </mat-card-header>
    </div>
</div>